const initialState = {
  employees: [],
  selectedEmployee: null,
  salaryDetails: null,
  loading: false,
  actionLoading: false,
  error: null,
  total: 0
};

const EmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Employees
    case 'FETCH_EMPLOYEES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_EMPLOYEES_SUCCESS':
      return {
        ...state,
        loading: false,
        employees: action.payload.employees || [],
        total: action.payload.total || 0,
        error: null
      };
    case 'FETCH_EMPLOYEES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Get Employee by ID
    case 'GET_EMPLOYEE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_EMPLOYEE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        selectedEmployee: action.payload,
        error: null
      };
    case 'GET_EMPLOYEE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Create Employee
    case 'CREATE_EMPLOYEE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_EMPLOYEE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        employees: [action.payload, ...state.employees],
        error: null
      };
    case 'CREATE_EMPLOYEE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Employee
    case 'UPDATE_EMPLOYEE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_EMPLOYEE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        employees: state.employees.map((e) => (e.id === action.payload.id ? action.payload : e)),
        selectedEmployee: action.payload,
        error: null
      };
    case 'UPDATE_EMPLOYEE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Delete Employee
    case 'DELETE_EMPLOYEE_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'DELETE_EMPLOYEE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        employees: state.employees.filter((e) => e.id !== action.payload),
        error: null
      };
    case 'DELETE_EMPLOYEE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Employee Salary Details
    case 'FETCH_EMPLOYEE_SALARY_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_EMPLOYEE_SALARY_SUCCESS':
      return {
        ...state,
        loading: false,
        salaryDetails: action.payload,
        error: null
      };
    case 'FETCH_EMPLOYEE_SALARY_FAILURE':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default EmployeeReducer;
